import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { fetchCareerAdvice } from "./CareerAdviceAPI";

export const fetchCareerAdviceAsync = createAsyncThunk(
    "careerAdvice/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchCareerAdvice();
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || "Something went wrong");
        }
    }
);

const careerAdviceSlice = createSlice({
    name: "careerAdvice",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCareerAdviceAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCareerAdviceAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchCareerAdviceAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const selectCareerAdviceData = (state) => state.careerAdvice.data;

export default careerAdviceSlice.reducer;